import BackArrowTitle from './BackArrowTitle';

export default BackArrowTitle;